/** Resize an existing Tripsi CDN URL without re-wrapping its encoded source URL. */
export default function cdnImageUrl(url, width, height) {
  if (!url) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.hostname === "api.tripsi.pl" && parsed.pathname === "/api/cdn/image") {
      parsed.searchParams.set("w", String(width));
      parsed.searchParams.set("h", String(height));
      return parsed.toString();
    }
  } catch {
    return url;
  }
  return url;
}
